import '../styles/channelLayoutStyles.css';
import { ChannelIcons } from '../utils/constants';
import { getChannelGraphicsUrl } from '../utils/helpers';
import React, { useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import {
  ThemeProvider,
} from '@aws-amplify/ui-react';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
dayjs.extend(utc);

// API path vars
const myAPI = "api94d03d7c"
const addActionPath = "/add-schedule-action"

// Custom Themes
const theme = {
  name: 'table-theme',
  tokens: {
    components: {
      table: {
        row: {
          hover: {
            backgroundColor: { value: '{colors.brand.secondary[60]}' },
          },
        },
      },
    },
  },
  name: 'button-theme',
  tokens: {
    colors: {
      border: {
        primary: { value: 'black' },
      },
    },
    components: {
      button: {
        backgroundColor: { value: "#6a5acd" },

      },
    },     
  },
};

export default function AddAction({channel, currentActions}) {

    // State vars
    const [open, setOpen] = useState(false);
    const [actionName, setActionName] = useState('');
    const [actionType, setActionType] = useState('');
    const [startType, setStartType] = useState('');
    const [dateTimeValue, setDateTimeValue] = useState(null);
    const [duration, setDuration] = useState(0);
    const [delay, setDelay] = useState(0);
    const [URL, setURL] = useState('');
    const [durationDisabled, setDurationDisabled] = useState(false);
    const [delayDisabled, setDelayDisabled] = useState(false);
    const [URLDisabled, setURLDisabled] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [actionNameInvalid, setActionNameInvalid] = useState(false);
    const [actionErrorMessage, setActionErrorMessage] = useState('');
    const [actionStartTimeInvalid, setActionStartTimeInvalid] = useState(false);
    const [actionStartTimeErrorMessage, setActionStartTimeErrorMessage] = useState('');

    // Get channel Singular URL 
    let channelURL = getChannelGraphicsUrl(channel);
    console.log(channelURL);
    console.log(channel);

    // Assigning props
    const actionChannel={channel}
    const actions={currentActions}

    // Functions to handle form input
    const handleNameChange = (event) => {
      setActionName(event.target.value);
    };

    const handleActionTypeChange = (event) => {
        setActionType(event.target.value);
    };

    const handleStartTypeChange = (event) => {
        setStartType(event.target.value);
    };

    const handleDurationChange = (event) => {
        setDuration(event.target.value);
    };

    const handleDelayChange = (event) => {
        setDelay(event.target.value);
        console.log(delay);
    };
    //Delete 
    const handleURLChange = (event) => {
        setURL(event.target.value);
    };

    const handleDateChange = (event) => {
      setDateTimeValue(event.target.value);
    }
    
    const handleClickOpen = () => {
        setOpen(true);
    };
    
    const handleClose = () => {
      setActionName('');
      setActionType('');
      setStartType('');
      setDateTimeValue(null);
      setDuration(0);
      setDelay(0);
      setURL('');
      setDurationDisabled(false);
      setURLDisabled(false);
      setOpen(false);
    };

    const handleSubmit = () => {
      let event_body = {
        "body": {
          "channel": actionChannel["channel"].toUpperCase()
        }
      };
      // Validation for fields needed in add action lambda.
      // Toast error if no action name.
      if(!actionName) {
        toast.error('Action Name is missing.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
        });
        event_body = {};
        return;
      } else if(actionErrorMessage) {
        toast.error('Action Name is not unique.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
        });
        event_body = {};
        return;
      } else {
        event_body["body"]["actionName"] = actionName
      }
      // Toast error if no action type.
      if(!actionType) {
        toast.error('Action Type is not selected.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
        });
        event_body = {};
        return;
      } else {
        event_body["body"]["actionType"] = actionType
      }
      // Toast error if no action start type.
      if(!startType) {
        toast.error('Start Type is not selected.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
        });
        event_body = {};
        return;
      } else {
        event_body["body"]["actionStart"] = startType
        if(startType === 'Fixed') {
        // Toast error if no date/time selected.
          if(!dateTimeValue) {
            toast.error('A date/time value must be selected. When a fixed date/time is selected it must be 2 minutes ahead of current time.', {
              position: "top-right",
              autoClose: 8000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
            });
          } else {
            // Validate datepicker time is 2 min ahead of current time
            // Note - The time picker converts to UTC but displays in current time zone in       console, so no need to convert to UTC in lambda.
            // Get current date
            const time_now_js = new Date();
            console.log(time_now_js)

            const time_diff = dateTimeValue.diff(time_now_js, 'minutes');
            console.log("This is selected time ", dateTimeValue)
            console.log("This is the diff ", time_diff)
            if(time_diff < 2) {
              toast.error('Selected date/time is not greater than 2 minutes from current time.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
              });
              event_body = {};
              return;
            } else {
              event_body["body"]["utcStartTime"] = dateTimeValue;
            }
            console.log(time_diff)
          }
        }
      } 
      if(actionType === 'Motion Graphics Activate') {
        // Validate a URL is selected when it's an activate action.
        if(!URL) {
          toast.error('URL must be selected. Also, verify duration is accurate.', {
            position: "top-right",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
          });
          event_body = {};
          return;
        } else {
          event_body["body"]["url"] = URL;
          console.log(URL)
        }
        if(parseInt(duration) > 86400000) {
          toast.error('Duration must not be greater than 86400000', {
            position: "top-right",
            autoClose: 6000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
          });
          event_body = {};
          return;
        } else {
          event_body["body"]["duration"] = duration;
        }
      }
      console.log(event_body)
      API.post(myAPI, addActionPath, event_body)
      .then(response => {
        console.log(response);
        handleClose();
      })
      .catch(error => {
        console.log(error);
        toast.error(error, {
          position: "top-right",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
        });
      })
    }
  

    // Determine visibility for duration and URL
    useEffect(() => {
      if(actionType === 'Motion Graphics Activate') {
        setDurationDisabled(false);
        setDelayDisabled(false);
        setURLDisabled(false);
      } else {
        setDurationDisabled(true);
        setDelayDisabled(true);
        setURLDisabled(true);
      }
    }, [actionType]);

    // Determine visibility for calendar
    useEffect(() => {
      if(startType === 'Immediate') {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }, [startType]);

    // Error field if action name already exists
    useEffect(() => {
      // Extract action names to a list for validation
      let actionNameList = []
      for(let action in actions) {
        let single_action = actions[action]
        for(let element in single_action) {
          actionNameList.push(single_action[element]['action_name']);
        }
      }

      console.log("Action Name is ", actionName)
      console.log(actionNameList)

      if(actionNameList.includes(actionName)) {
        setActionNameInvalid(true);
        setActionErrorMessage("Action name must be unique. Please try again.")
      }
      else {
        setActionNameInvalid(false)
        setActionErrorMessage('')
      }
    }, [actionName]);

    // Modify Singular URL if there is a delay added
    useEffect(() => {
      console.log(channelURL)
      console.log(URL)
      if(delay > 0) {
        let modifiedURL = channelURL + "&graphicsdelay=" + delay + "000";
        setURL(modifiedURL)
      }
      else if (delay === 0) {
        setURL(channelURL)
      }
    }, [delay]);
    
    return (
        <ThemeProvider theme={theme} colorMode="light">
            <div className="crawl-button">
                <Button className="crawl-button-design" onClick={handleClickOpen}>
                    Add Action
                </Button>
            </div>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Create Schedule Action</DialogTitle>
                <DialogContent>
                <DialogContentText>
                    Enter information below to add a new action to the channel. Actions turn HTML5 graphics on and off.
                    Each enabled field is required.
                </DialogContentText>
                <Stack spacing={2} margin={2}>
                    <TextField 
                        id="outlined-basic"
                        label="Enter Action Name" 
                        variant="outlined"
                        fullWidth
                        value={actionName}
                        helperText={actionErrorMessage}
                        error={actionNameInvalid}
                        onChange={handleNameChange} />
                    <div>
                        <Box sx={{ minWidth: 120 }}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Enter Action Type</InputLabel>
                            <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Enter Action Type"
                            value={actionType}
                            onChange={handleActionTypeChange}
                            >
                            <MenuItem value="Motion Graphics Activate">Motion Graphics Activate</MenuItem>
                            <MenuItem value="Motion Graphics Deactivate">Motion Graphics Deactivate</MenuItem>
                            </Select>
                        </FormControl>
                        </Box>
                    </div>
                    <div>
                        <Box sx={{ minWidth: 120 }}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Enter Start Type</InputLabel>
                            <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Start Type"
                            value={startType}
                            onChange={handleStartTypeChange}
                            >
                            <MenuItem value="Immediate">Immediate</MenuItem>
                            <MenuItem value="Fixed">Fixed</MenuItem>
                            </Select>
                        </FormControl>
                        </Box>
                    </div>
                    <DateTimePicker
                      label="Start Time" 
                      value={dateTimeValue}
                      disabled={disabled}
                      // shouldDisableDate={startType}
                      onChange={(newDate) => setDateTimeValue(newDate)}
                      helperText={actionStartTimeErrorMessage}
                      error={actionStartTimeInvalid}                                         
                    />  
                    <TextField 
                        id="outlined-basic"
                        label="Duration (in milliseconds)" 
                        variant="outlined"
                        value={duration}
                        disabled={durationDisabled}
                        onChange={handleDurationChange}
                        fullWidth />
                    <TextField 
                        id="outlined-basic"
                        label="Crawl Delay (in seconds)" 
                        variant="outlined"
                        value={delay}
                        disabled={delayDisabled}
                        onChange={handleDelayChange}
                        fullWidth />
                    {/* <div>
                        <Box sx={{ minWidth: 120 }}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">URL</InputLabel>
                            <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Select the Singular URL for the channel."
                            value={URL}
                            disabled={URLDisabled}
                            onChange={handleURLChange}
                            >
                            {ChannelIcons.map((channel) => (
                              <MenuItem value={channel.url}>
                                {channel.text} - {channel.url} 
                              </MenuItem>

                            ))}                                                                    
                            </Select>
                        </FormControl>
                        </Box>
                    </div> */}
                </Stack>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSubmit}>Submit</Button>
                <ToastContainer />
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}

